// extracted by mini-css-extract-plugin
export default {"container":"table-actions-component_container__PCHVQ","truncate-table":"table-actions-component_truncate-table__PZR1d","table-text-faded":"table-actions-component_table-text-faded__TFuJU","push":"table-actions-component_push__UNmBm","smallButton":"table-actions-component_smallButton__fWnfa","removeButton":"table-actions-component_removeButton__2OZCC","editButton":"table-actions-component_editButton__MRDLP"};
    if(module.hot) {
      // 1793877078730
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  